import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch"; // Seu componente de busca
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  onClick: (e: any) => void,
  setEmpreendId: (e: any) => void,
  setEmpreendNome: (e: any) => void,
  filteredInfo: {
    empreend?: string[] | null;
    cidadeId?: string[] | null;
    cronograma?: string[] | null;
    origem?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Empreendimento",
      dataIndex: "empreendimento",
      key: "empreendimento",
      width: "30%",
      filteredValue: filteredInfo.empreend || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.empreendimento.includes(value),
      ...ColumnSearch<any>({ dataIndex: "empreendimento" }),
    },
    {
      title: "Cidade",
      dataIndex: "cidadeId",
      key: "cidadeId",
      width: "30%",
      filteredValue: filteredInfo.cidadeId || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.cidadeId.includes(value),
      ...ColumnSearch<any>({ dataIndex: "cidadeId" }),
    },

    {
      title: "Cronograma",
      dataIndex: "cronograma",
      key: "cronograma",
      width: "30%",
      filteredValue: filteredInfo.cronograma || null,
      onFilter: (value, record) => record.cronograma.includes(value),
      ...ColumnSearch<any>({ dataIndex: "cronograma" }),
    },
    {
      title: "Cotas Usuários",
      dataIndex: "cotasUsuarios",
      key: "cotasUsuarios",
      width: "20%",
      render: (value) => value ?? 0,
    },

    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      width: "30%",
      filteredValue: filteredInfo.origem || null,
      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuário" },
      ],
      onFilter: (value, record) => record.origem.includes(value),
      filterSearch: true,
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setEmpreendId(row.key);
                setEmpreendNome(row.empreendimento);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
